import { SAVEUSERDETAIL } from '../constact'

const saveUserDettail = data => ({
    type: SAVEUSERDETAIL,
    data
})
export default saveUserDettail;